/**
 * ExportFilterDialog - Dialog para selecionar filtro de exportação
 *
 * Permite ao usuário escolher quais domínios exportar para o ScrapAudience
 * baseado em critérios como falta de dados ou status pendente.
 */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Typography,
  Box,
  DialogContent,
  DialogActions
} from '@mui/material';
import { GetApp as GetAppIcon } from '@mui/icons-material';
import PlatformDialog from '../../../molecules/PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../../../molecules/PlatformDialog/PlatformDialogTitle';

const ExportFilterDialog = ({
  open,
  onClose,
  filterType,
  onFilterTypeChange,
  exportFormat = 'json',
  onExportFormatChange,
  onExport
}) => {
  const theme = useTheme();

  return (
    <PlatformDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <PlatformDialogTitle 
        title="Exportar Domínios"
        subtitle="Prepare dados para o ScrapAudience."
        icon={<GetAppIcon />}
        onClose={onClose}
        color="secondary"
      />
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Selecione o critério de exportação para a coleta de dados:
        </Typography>
        <FormControl fullWidth size="small" sx={{ mb: 3 }}>
          <InputLabel>Critério de Exportação</InputLabel>
          <Select
            value={filterType}
            onChange={(e) => onFilterTypeChange(e.target.value)}
            label="Critério de Exportação"
            sx={{ borderRadius: 2 }}
          >
            <MenuItem value="missing">Sem Dados de Audiência</MenuItem>
            <MenuItem value="outdated">Desatualizados (&gt;30 dias)</MenuItem>
            <MenuItem value="pending">Status Pendente</MenuItem>
            <MenuItem value="all">Todos os Domínios Ativos</MenuItem>
          </Select>
        </FormControl>

        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, mb: 1, display: 'block' }}>
          Formato do Arquivo
        </Typography>
        <Box display="flex" gap={1.5} mb={3}>
          <Button
            variant={exportFormat === 'json' ? 'contained' : 'outlined'}
            onClick={() => onExportFormatChange && onExportFormatChange('json')}
            size="small"
            fullWidth
            sx={{ borderRadius: 2, height: 40, fontWeight: 600 }}
          >
            JSON (Sistema)
          </Button>
          <Button
            variant={exportFormat === 'excel' ? 'contained' : 'outlined'}
            onClick={() => onExportFormatChange && onExportFormatChange('excel')}
            color="success"
            size="small"
            fullWidth
            sx={{ borderRadius: 2, height: 40, fontWeight: 600 }}
          >
            Excel (.xlsx)
          </Button>
        </Box>

        <Alert severity="info" variant="outlined" sx={{ borderRadius: 2 }}>
          O arquivo será gerado e baixado para o seu computador.
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
        <Button onClick={onClose} sx={{ fontWeight: 600 }}>Cancelar</Button>
        <Button 
          onClick={onExport} 
          variant="contained" 
          color="secondary"
          sx={{ fontWeight: 700, borderRadius: 2, px: 3 }}
          startIcon={<GetAppIcon />}
        >
          Iniciar Download
        </Button>
      </DialogActions>
    </PlatformDialog>
  );
};

export default ExportFilterDialog;
